var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.bots && (_vm.gridData.calendar || _vm.gridData.monthlyCalendar)
    ? _c(
        "div",
        {
          ref: "loadableCalendar",
          staticClass:
            "calendar-wrapper table-wrapper scrollable calendar-table",
          class: _vm.name + "-table",
        },
        [
          _c(
            "div",
            { staticClass: "select-week" },
            [
              _c(
                "div",
                {
                  staticClass: "previous",
                  on: {
                    click: function ($event) {
                      return _vm.changeWeek(
                        "previous",
                        null,
                        _vm.gridData.monthlyCalendar
                      )
                    },
                  },
                },
                [
                  _c(
                    "i",
                    {
                      staticClass:
                        "vs-icon notranslate icon-scale material-icons null",
                    },
                    [_vm._v("chevron_left")]
                  ),
                ]
              ),
              _c("component-datepicker", {
                staticClass: "posts-datepicker",
                attrs: {
                  date: new Date(_vm.currentDate),
                  noLimit: true,
                  eventOpen: _vm.openDatePicker,
                },
                on: { picked: _vm.picked },
              }),
              _vm.gridData.monthlyCalendar
                ? _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          _vm.openDatePicker = !_vm.openDatePicker
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          `${_vm.$t(`dash.planner.month`)} ${_vm.startDate
                            .locale(this.$i18n.locale)
                            .format("MMMM")} ${_vm.startDate
                            .locale(this.$i18n.locale)
                            .format("YYYY")} `
                        )
                      ),
                    ]
                  )
                : _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          _vm.openDatePicker = !_vm.openDatePicker
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          `${_vm.$t(`dash.planner.week`)} ${_vm.startDate
                            .locale(this.$i18n.locale)
                            .format("LL")}`
                        )
                      ),
                    ]
                  ),
              _c(
                "div",
                {
                  staticClass: "next",
                  on: {
                    click: function ($event) {
                      return _vm.changeWeek(
                        "next",
                        null,
                        _vm.gridData.monthlyCalendar
                      )
                    },
                  },
                },
                [
                  _c(
                    "i",
                    {
                      staticClass:
                        "vs-icon notranslate icon-scale material-icons null",
                    },
                    [_vm._v("chevron_right")]
                  ),
                ]
              ),
            ],
            1
          ),
          _vm.gridData.calendar
            ? _c("div", { staticClass: "scroll-hour" }, [
                _c("label", { attrs: { for: "from-hour" } }, [
                  _vm._v(_vm._s(_vm.$t(`dash.planner.hours-period.from`))),
                ]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.showStartHour,
                        expression: "showStartHour",
                      },
                    ],
                    attrs: { id: "from-hour" },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.showStartHour = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          return _vm.checkValidPeriod("start")
                        },
                      ],
                    },
                  },
                  _vm._l(
                    _vm.gridData.calendar.monday.slots,
                    function (hour, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: index } },
                        [_vm._v(_vm._s(index) + " h")]
                      )
                    }
                  ),
                  0
                ),
                _c("label", { attrs: { for: "to-hour" } }, [
                  _vm._v(_vm._s(_vm.$t(`dash.planner.hours-period.to`))),
                ]),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.showEndHour,
                        expression: "showEndHour",
                      },
                    ],
                    attrs: { id: "to-hour" },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.showEndHour = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          return _vm.checkValidPeriod("end")
                        },
                      ],
                    },
                  },
                  _vm._l(
                    _vm.gridData.calendar.monday.slots,
                    function (hour, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: index } },
                        [_vm._v(_vm._s(index) + " h")]
                      )
                    }
                  ),
                  0
                ),
              ])
            : _vm._e(),
          _vm.pageWithAutoPost &&
          _vm.gridData.calendar &&
          !["Viewer"].includes(_vm.getUserRole)
            ? _c(
                "div",
                {
                  staticClass: "show-empty-slots",
                  on: {
                    click: function ($event) {
                      return _vm.toggleShowEmptySlots()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(
                        _vm.$t(
                          `dash.planner.${
                            _vm.showEmptySlots ? "hide" : "show"
                          }-empty-slot`
                        )
                      ) +
                      " \n  "
                  ),
                ]
              )
            : _vm._e(),
          _vm.gridData.calendar
            ? _c(
                "div",
                {
                  ref: "loadableCalendarContent",
                  staticClass: "calendar-content",
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "calendar-body",
                      attrs: { id: "calendar-content-hours" },
                    },
                    [
                      _c("li", { staticClass: "column hours" }, [
                        _c(
                          "ul",
                          {
                            staticClass: "calendar-head",
                            class: { fixed: _vm.fixedDays },
                          },
                          [_c("li", { staticClass: "column hours-column" })]
                        ),
                        _c(
                          "ul",
                          _vm._l(
                            _vm.gridData.calendar.monday.slots,
                            function (hour, index) {
                              return _c(
                                "li",
                                {
                                  key: index,
                                  staticClass: "row hour no-background",
                                  class: `hour-${index} ${
                                    _vm.showStartHour > index ||
                                    index > _vm.showEndHour
                                      ? "hide"
                                      : ""
                                  }`,
                                  style: `height: ${_vm.getHeightHour(
                                    index
                                  )}px; min-height: ${
                                    _vm.maxPostsHour(index) == 0 ? 30 : 50
                                  }px`,
                                },
                                [
                                  _c("div", [
                                    _vm._v(_vm._s(index)),
                                    _c("span", [_vm._v("h")]),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "scrollable-x" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "calendar-body head-days",
                        attrs: { id: "calendar-content-days" },
                      },
                      _vm._l(_vm.gridData.calendar, function (day, key) {
                        return _c(
                          "li",
                          {
                            key: key,
                            staticClass: "column day",
                            class: `day-${key}`,
                          },
                          [
                            _c(
                              "ul",
                              {
                                staticClass: "calendar-head",
                                class: { fixed: _vm.fixedDays },
                              },
                              [
                                _c("li", { staticClass: "column day-column" }, [
                                  _c(
                                    "p",
                                    {
                                      class: [
                                        {
                                          past: _vm.checkPast(
                                            day.day,
                                            _vm.currentDate.hours()
                                          ),
                                          current: _vm.checkCurrent(day.day),
                                        },
                                      ],
                                    },
                                    [
                                      _c("span", { staticClass: "day" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm
                                              .$t(
                                                `dash.week.${_vm
                                                  .formatDayEn(day.day, "dddd")
                                                  .toLowerCase()}`
                                              )
                                              .substr(0, 3)
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.formatDate(day.day, "DD")
                                            )
                                        ),
                                      ]),
                                      _c("span", { staticClass: "posts" }, [
                                        _vm._v(_vm._s(_vm.nbPostsDay(key))),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _c(
                      "ul",
                      {
                        staticClass: "calendar-body scrollable",
                        attrs: { id: "calendar-content" },
                        on: { scroll: _vm.handleScroll },
                      },
                      [
                        _vm.activeDropZone
                          ? _c("div", {
                              staticClass: "drag-scroll-top",
                              on: {
                                dragover: function ($event) {
                                  return _vm.dragOver($event, "top")
                                },
                              },
                            })
                          : _vm._e(),
                        _vm.activeDropZone
                          ? _c("div", {
                              staticClass: "drag-scroll-bottom",
                              on: {
                                dragover: function ($event) {
                                  return _vm.dragOver($event, "bottom")
                                },
                              },
                            })
                          : _vm._e(),
                        _vm.showCursor &&
                        _vm.positionCursorHour > 0 &&
                        (_vm.showStartHour > 0 || _vm.showEndHour < 23)
                          ? _c(
                              "div",
                              {
                                staticClass: "cursor-current-hour",
                                style: `top: ${_vm.positionCursorHour}px`,
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.currentDate.format("HH:mm"))
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._l(_vm.gridData.calendar, function (day, key) {
                          return _c(
                            "li",
                            {
                              key: key,
                              staticClass: "column day",
                              class: `day-${key}`,
                            },
                            [
                              _c(
                                "ul",
                                {
                                  staticClass: "hours",
                                  class: { current: _vm.checkCurrent(day.day) },
                                },
                                _vm._l(day.slots, function (hour, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: index,
                                      staticClass: "row hour",
                                      class: [
                                        `hour-${index}`,
                                        _vm.showStartHour > index ||
                                        index > _vm.showEndHour
                                          ? "hide"
                                          : "",
                                        {
                                          out:
                                            _vm.checkPlanning(key, index) &&
                                            !["Viewer"].includes(
                                              _vm.getUserRole
                                            ),
                                          current: _vm.isNow(day.day, index),
                                        },
                                      ],
                                      style: `height: ${_vm.getHeightHour(
                                        index
                                      )}px; min-height: ${
                                        _vm.maxPostsHour(index) == 0 ? 30 : 50
                                      }px`,
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPost(day.day, index)
                                        },
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "hour" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm
                                              .$t(
                                                `dash.week.${_vm
                                                  .formatDayEn(day.day, "dddd")
                                                  .toLowerCase()}`
                                              )
                                              .substr(0, 3)
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.formatDate(day.day, "DD/MM")
                                            ) +
                                            " | " +
                                            _vm._s(index) +
                                            "h"
                                        ),
                                      ]),
                                      _c(
                                        "ul",
                                        { staticClass: "posts" },
                                        [
                                          _vm._l(
                                            hour,
                                            function (post, indexPost) {
                                              return _c(
                                                "div",
                                                {
                                                  key: indexPost,
                                                  staticClass: "post-cell",
                                                  on: { dragend: _vm.dragEnd },
                                                },
                                                [
                                                  _vm.showPost(post)
                                                    ? _c(
                                                        "li",
                                                        {
                                                          staticClass: "post",
                                                          class: [
                                                            post.status,
                                                            {
                                                              reshare:
                                                                post.page &&
                                                                post.page[0] &&
                                                                post.page[0]
                                                                  .is_reshare,
                                                            },
                                                            {
                                                              retweet:
                                                                post.page &&
                                                                post.page[0] &&
                                                                post.page[0]
                                                                  .is_retweet,
                                                            },
                                                            {
                                                              story:
                                                                (post.page &&
                                                                  post
                                                                    .page[0] &&
                                                                  (post.page[0]
                                                                    .story ||
                                                                    post.page[0]
                                                                      .story_standard_api)) ||
                                                                (post.draft &&
                                                                  (post.draft
                                                                    .type ===
                                                                    "story" ||
                                                                    post.draft
                                                                      .data
                                                                      .typePost ===
                                                                      "story")),
                                                            },
                                                          ],
                                                          attrs: {
                                                            "data-qa": `planner-post-${post.status}`,
                                                            draggable:
                                                              ![
                                                                "Viewer",
                                                              ].includes(
                                                                _vm.getUserRole
                                                              ) &&
                                                              [
                                                                "scheduled",
                                                                "draft",
                                                              ].includes(
                                                                post.status
                                                              ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              $event.preventDefault()
                                                              return _vm.clickPost(
                                                                _vm.gridData
                                                                  .pages,
                                                                post
                                                              )
                                                            },
                                                            dragstart:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.startDragPost(
                                                                  $event,
                                                                  post,
                                                                  index
                                                                )
                                                              },
                                                            dragover: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          post._bots &&
                                                          post._bots.length &&
                                                          post._bots[0].page &&
                                                          post._bots[0].page
                                                            .name
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "page-rs",
                                                                },
                                                                [
                                                                  _c(
                                                                    "Tooltip",
                                                                    {
                                                                      attrs: {
                                                                        text: post
                                                                          ._bots[0]
                                                                          .page
                                                                          .name,
                                                                        position:
                                                                          "top",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "page-image-avatar",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              page: post
                                                                                ._bots[0]
                                                                                .page,
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                       \n                    "
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          post.page &&
                                                          post.page.length &&
                                                          ((post.page[0]
                                                            .wait_validation &&
                                                            (typeof post.page[0]
                                                              .wait_validation ==
                                                              "object" ||
                                                              JSON.parse(
                                                                post.page[0]
                                                                  .wait_validation
                                                              ))) ||
                                                            post.page[0]
                                                              .affectedTo)
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "affected-to",
                                                                },
                                                                [
                                                                  _c(
                                                                    "Tooltip",
                                                                    {
                                                                      attrs: {
                                                                        text: _vm.$t(
                                                                          post
                                                                            .page[0]
                                                                            .wait_validation &&
                                                                            (typeof post
                                                                              .page[0]
                                                                              .wait_validation ==
                                                                              "object" ||
                                                                              JSON.parse(
                                                                                post
                                                                                  .page[0]
                                                                                  .wait_validation
                                                                              ))
                                                                            ? "dash.posts.validated"
                                                                            : "dash.posts.affected_and_not_validated"
                                                                        ),
                                                                        position:
                                                                          "top",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              src: require(post
                                                                                .page[0]
                                                                                .wait_validation &&
                                                                                (typeof post
                                                                                  .page[0]
                                                                                  .wait_validation ==
                                                                                  "object" ||
                                                                                  JSON.parse(
                                                                                    post
                                                                                      .page[0]
                                                                                      .wait_validation
                                                                                  ))
                                                                                ? "../../assets/img/check_mark_accept_icon.svg"
                                                                                : "../../assets/img/check_mark_accept_icon_grey.svg"),
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        "\n                       \n                    "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          post.page &&
                                                          post.page[0] &&
                                                          post.page[0]
                                                            .story_multiple
                                                            ? _vm._l(
                                                                JSON.parse(
                                                                  post.page[0]
                                                                    .story_multiple
                                                                ).allStories,
                                                                function (
                                                                  story,
                                                                  indexStory
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: indexStory,
                                                                      staticClass:
                                                                        "story-multiple",
                                                                      class:
                                                                        indexStory +
                                                                          1 <
                                                                        JSON.parse(
                                                                          post
                                                                            .page[0]
                                                                            .story_multiple
                                                                        )
                                                                          .nbCurrent
                                                                          ? "posted"
                                                                          : post.status,
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            $event.stopPropagation()
                                                                            $event.preventDefault()
                                                                            return _vm.clickPost(
                                                                              _vm
                                                                                .gridData
                                                                                .pages,
                                                                              post,
                                                                              indexStory
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      indexStory
                                                                        ? _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "link",
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "content",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "Tooltip",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  text: `Story n°${
                                                                                    indexStory +
                                                                                    1
                                                                                  }/${
                                                                                    JSON.parse(
                                                                                      post
                                                                                        .page[0]
                                                                                        .story_multiple
                                                                                    )
                                                                                      .nbTotal
                                                                                  }`,
                                                                                  position:
                                                                                    "top",
                                                                                },
                                                                            },
                                                                            [
                                                                              story
                                                                                .data
                                                                                .video
                                                                                ? _c(
                                                                                    "div",
                                                                                    [
                                                                                      _c(
                                                                                        "video",
                                                                                        {
                                                                                          staticClass:
                                                                                            "story-screenshot-planner",
                                                                                          attrs:
                                                                                            {
                                                                                              src: story
                                                                                                .data
                                                                                                .video,
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : story
                                                                                    .data
                                                                                    .enclosure
                                                                                ? _c(
                                                                                    "div",
                                                                                    [
                                                                                      _c(
                                                                                        "img",
                                                                                        {
                                                                                          staticClass:
                                                                                            "story-screenshot-planner",
                                                                                          attrs:
                                                                                            {
                                                                                              src: story
                                                                                                .data
                                                                                                .enclosure,
                                                                                            },
                                                                                          on: {
                                                                                            error:
                                                                                              _vm.replaceByDefault,
                                                                                          },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "title",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.getText(
                                                                                        story.data
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "info",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "date",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.getDate(
                                                                                    post
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          post.status !=
                                                                          "slot"
                                                                            ? _c(
                                                                                "Tooltip",
                                                                                {
                                                                                  staticClass:
                                                                                    "type",
                                                                                  class:
                                                                                    _vm.getTypePost(
                                                                                      post
                                                                                    ),
                                                                                  attrs:
                                                                                    {
                                                                                      text: _vm.$t(
                                                                                        _vm.getTypeTooltip(
                                                                                          post
                                                                                        )
                                                                                      ),
                                                                                      position:
                                                                                        "top",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          _vm.getTypePost(
                                                                                            post
                                                                                          )
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          indexStory +
                                                                            1 <
                                                                          JSON.parse(
                                                                            post
                                                                              .page[0]
                                                                              .story_multiple
                                                                          )
                                                                            .nbCurrent
                                                                            ? _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "state",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        `dash.post.posted`
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "state",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        `dash.post.${post.status}`
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            : post.status ==
                                                                "preview" ||
                                                              post.status ==
                                                                "slot" ||
                                                              post.status ==
                                                                "failed" ||
                                                              post.status ==
                                                                "inprogress" ||
                                                              (post.page &&
                                                                post.page[0] &&
                                                                (post.page[0]
                                                                  .story ||
                                                                  post.page[0]
                                                                    .story_standard_api))
                                                            ? [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "content",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "Tooltip",
                                                                      {
                                                                        attrs: {
                                                                          text: _vm.$t(
                                                                            _vm.getTooltip(
                                                                              post
                                                                            )
                                                                          ),
                                                                          position:
                                                                            "top",
                                                                        },
                                                                      },
                                                                      [
                                                                        ((post.page &&
                                                                          post
                                                                            .page[0] &&
                                                                          (post
                                                                            .page[0]
                                                                            .story ||
                                                                            post
                                                                              .page[0]
                                                                              .story_standard_api)) ||
                                                                          (post.draft &&
                                                                            post
                                                                              .draft
                                                                              .type ===
                                                                              "story")) &&
                                                                        ((post.page &&
                                                                          post
                                                                            .page[0] &&
                                                                          post
                                                                            .page[0]
                                                                            .video) ||
                                                                          (post.page &&
                                                                            post
                                                                              .page[0] &&
                                                                            post
                                                                              .page[0]
                                                                              .enclosure &&
                                                                            post.page[0].enclosure.endsWith(
                                                                              ".mp4"
                                                                            )) ||
                                                                          (post.draft &&
                                                                            post
                                                                              .draft
                                                                              .data
                                                                              .videos &&
                                                                            _vm.getUrlVideoDraft(
                                                                              post
                                                                                .draft
                                                                                .data
                                                                                .videos,
                                                                              post
                                                                                .page[0]
                                                                                .network,
                                                                              post
                                                                                .draft
                                                                                .type,
                                                                              post
                                                                                .draft
                                                                                .data
                                                                                .videoReel
                                                                            )))
                                                                          ? _c(
                                                                              "div",
                                                                              {},
                                                                              [
                                                                                _c(
                                                                                  "video",
                                                                                  {
                                                                                    staticClass:
                                                                                      "story-screenshot-planner",
                                                                                    attrs:
                                                                                      {
                                                                                        src:
                                                                                          post.page &&
                                                                                          post
                                                                                            .page[0] &&
                                                                                          post
                                                                                            .page[0]
                                                                                            .video
                                                                                            ? post
                                                                                                .page[0]
                                                                                                .video
                                                                                            : post.page &&
                                                                                              post
                                                                                                .page[0] &&
                                                                                              post
                                                                                                .page[0]
                                                                                                .enclosure &&
                                                                                              post.page[0].enclosure.endsWith(
                                                                                                ".mp4"
                                                                                              )
                                                                                            ? post
                                                                                                .page[0]
                                                                                                .enclosure
                                                                                            : _vm.getUrlVideoDraft(
                                                                                                post
                                                                                                  .draft
                                                                                                  .data
                                                                                                  .videos,
                                                                                                post
                                                                                                  .page[0]
                                                                                                  .network,
                                                                                                post
                                                                                                  .draft
                                                                                                  .type,
                                                                                                post
                                                                                                  .draft
                                                                                                  .data
                                                                                                  .videoReel
                                                                                              ),
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : post.page &&
                                                                            post
                                                                              .page[0] &&
                                                                            post
                                                                              .page[0]
                                                                              .videoReel &&
                                                                            ((post.page &&
                                                                              post
                                                                                .page[0] &&
                                                                              post
                                                                                .page[0]
                                                                                .video) ||
                                                                              (post.page &&
                                                                                post
                                                                                  .page[0] &&
                                                                                post
                                                                                  .page[0]
                                                                                  .enclosure &&
                                                                                post.page[0].enclosure.endsWith(
                                                                                  ".mp4"
                                                                                )) ||
                                                                              (post.draft &&
                                                                                post
                                                                                  .draft
                                                                                  .data
                                                                                  .videos &&
                                                                                _vm.getUrlVideoDraft(
                                                                                  post
                                                                                    .draft
                                                                                    .data
                                                                                    .videos,
                                                                                  post
                                                                                    .page[0]
                                                                                    .network,
                                                                                  post
                                                                                    .draft
                                                                                    .type,
                                                                                  post
                                                                                    .draft
                                                                                    .data
                                                                                    .videoReel
                                                                                )))
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb-wrapper",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "video",
                                                                                  {
                                                                                    class: `video-thumb ${
                                                                                      ((post.page &&
                                                                                        post
                                                                                          .page[0] &&
                                                                                        post
                                                                                          .page[0]
                                                                                          .videoReel) ||
                                                                                        (post.draft &&
                                                                                          post
                                                                                            .draft
                                                                                            .data &&
                                                                                          post
                                                                                            .draft
                                                                                            .data
                                                                                            .videoReel)) &&
                                                                                      post.page &&
                                                                                      post
                                                                                        .page[0] &&
                                                                                      post
                                                                                        .page[0]
                                                                                        .network ==
                                                                                        "instagram" &&
                                                                                      "reel-video"
                                                                                    }`,
                                                                                    attrs:
                                                                                      {
                                                                                        width:
                                                                                          "37",
                                                                                        height:
                                                                                          "70",
                                                                                        src:
                                                                                          post.page &&
                                                                                          post
                                                                                            .page[0] &&
                                                                                          post
                                                                                            .page[0]
                                                                                            .video
                                                                                            ? post
                                                                                                .page[0]
                                                                                                .video
                                                                                            : post.page &&
                                                                                              post
                                                                                                .page[0] &&
                                                                                              post
                                                                                                .page[0]
                                                                                                .enclosure &&
                                                                                              post.page[0].enclosure.endsWith(
                                                                                                ".mp4"
                                                                                              )
                                                                                            ? post
                                                                                                .page[0]
                                                                                                .enclosure
                                                                                            : _vm.getUrlVideoDraft(
                                                                                                post
                                                                                                  .draft
                                                                                                  .data
                                                                                                  .videos,
                                                                                                post
                                                                                                  .page[0]
                                                                                                  .network,
                                                                                                post
                                                                                                  .draft
                                                                                                  .type,
                                                                                                post
                                                                                                  .draft
                                                                                                  .data
                                                                                                  .videoReel
                                                                                              ),
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm.hasScreenshot(
                                                                              post
                                                                            )
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "story-screenshot-planner",
                                                                                    attrs:
                                                                                      {
                                                                                        src: _vm.hasScreenshot(
                                                                                          post
                                                                                        ),
                                                                                      },
                                                                                    on: {
                                                                                      error:
                                                                                        _vm.replaceByDefault,
                                                                                    },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : post.status !=
                                                                              "slot" &&
                                                                            ((post
                                                                              ._bots[0] &&
                                                                              post
                                                                                ._bots[0]
                                                                                .mode ===
                                                                                "story" &&
                                                                              post
                                                                                ._bots[0]
                                                                                .page &&
                                                                              post
                                                                                ._bots[0]
                                                                                .page
                                                                                .story_config &&
                                                                              post
                                                                                ._bots[0]
                                                                                .page
                                                                                .story_config
                                                                                .created) ||
                                                                              (post._bots &&
                                                                                post
                                                                                  ._bots
                                                                                  .mode ===
                                                                                  "story" &&
                                                                                post
                                                                                  ._bots
                                                                                  .page &&
                                                                                post
                                                                                  ._bots
                                                                                  .page
                                                                                  .story_config &&
                                                                                post
                                                                                  ._bots
                                                                                  .page
                                                                                  .story_config
                                                                                  .created))
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "story-img-planner",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        src: post.enclosure,
                                                                                        alt: "",
                                                                                      },
                                                                                    on: {
                                                                                      error:
                                                                                        _vm.replaceByDefault,
                                                                                    },
                                                                                  }
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.getText(
                                                                                          post,
                                                                                          true
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : post.status !=
                                                                              "slot" &&
                                                                            post.enclosure
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb-wrapper",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "thumb",
                                                                                    attrs:
                                                                                      {
                                                                                        src: post.enclosure,
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : post.status !=
                                                                              "slot" &&
                                                                            post.page &&
                                                                            post
                                                                              .page[0] &&
                                                                            post
                                                                              .page[0]
                                                                              .enclosure
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb-wrapper",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "thumb",
                                                                                    attrs:
                                                                                      {
                                                                                        src: post
                                                                                          .page[0]
                                                                                          .enclosure,
                                                                                      },
                                                                                    on: {
                                                                                      error:
                                                                                        _vm.replaceByDefault,
                                                                                    },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : post.status !=
                                                                              "slot" &&
                                                                            post.page &&
                                                                            post
                                                                              .page[0] &&
                                                                            post
                                                                              .page[0]
                                                                              .carousel &&
                                                                            post
                                                                              .page[0]
                                                                              .carousel
                                                                              .length >
                                                                              1 &&
                                                                            post
                                                                              .page[0]
                                                                              .carousel[0]
                                                                              .url
                                                                          ? _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb-wrapper",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "thumb",
                                                                                    attrs:
                                                                                      {
                                                                                        src: post
                                                                                          .page[0]
                                                                                          .carousel[0]
                                                                                          .url,
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        post.status !=
                                                                        "slot"
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "title",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.getText(
                                                                                      post
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "title",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      `dash.post.slot.empty`
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "date",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getDate(
                                                                              post
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    post.status !=
                                                                    "slot"
                                                                      ? _c(
                                                                          "Tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "type",
                                                                            class:
                                                                              _vm.getTypePost(
                                                                                post
                                                                              ),
                                                                            attrs:
                                                                              {
                                                                                text: _vm.$t(
                                                                                  _vm.getTypeTooltip(
                                                                                    post
                                                                                  )
                                                                                ),
                                                                                position:
                                                                                  "top",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.getTypePost(
                                                                                      post
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "state",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              `dash.post.${post.status}`
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            : post.page &&
                                                              post.page[0] &&
                                                              post.page[0]
                                                                .is_reshare
                                                            ? [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "content",
                                                                  },
                                                                  [
                                                                    post.page &&
                                                                    post
                                                                      .page[0] &&
                                                                    post.page[0]
                                                                      .enclosure
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb",
                                                                                attrs:
                                                                                  {
                                                                                    src: post
                                                                                      .page[0]
                                                                                      .enclosure,
                                                                                  },
                                                                                on: {
                                                                                  error:
                                                                                    _vm.replaceByDefault,
                                                                                },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : post.enclosure
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb",
                                                                                attrs:
                                                                                  {
                                                                                    src: post.enclosure,
                                                                                  },
                                                                                on: {
                                                                                  error:
                                                                                    _vm.replaceByDefault,
                                                                                },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            post
                                                                              .page[0]
                                                                              .reshare_message
                                                                          ) +
                                                                            " - " +
                                                                            _vm._s(
                                                                              _vm.getText(
                                                                                post
                                                                              )
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "date",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getDate(
                                                                              post
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    post.status !=
                                                                    "slot"
                                                                      ? _c(
                                                                          "Tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "type",
                                                                            class:
                                                                              _vm.getTypePost(
                                                                                post
                                                                              ),
                                                                            attrs:
                                                                              {
                                                                                text: _vm.$t(
                                                                                  _vm.getTypeTooltip(
                                                                                    post
                                                                                  )
                                                                                ),
                                                                                position:
                                                                                  "top",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.getTypePost(
                                                                                      post
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "state",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              `dash.post.reshare`
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            : post.page &&
                                                              post.page[0] &&
                                                              post.page[0]
                                                                .is_retweet
                                                            ? [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "content",
                                                                  },
                                                                  [
                                                                    post.page &&
                                                                    post
                                                                      .page[0] &&
                                                                    post.page[0]
                                                                      .enclosure
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb",
                                                                                attrs:
                                                                                  {
                                                                                    src: post
                                                                                      .page[0]
                                                                                      .enclosure,
                                                                                  },
                                                                                on: {
                                                                                  error:
                                                                                    _vm.replaceByDefault,
                                                                                },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : post.enclosure
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb",
                                                                                attrs:
                                                                                  {
                                                                                    src: post.enclosure,
                                                                                  },
                                                                                on: {
                                                                                  error:
                                                                                    _vm.replaceByDefault,
                                                                                },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getText(
                                                                              post
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "date",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getDate(
                                                                              post
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    post.status !=
                                                                    "slot"
                                                                      ? _c(
                                                                          "Tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "type",
                                                                            class:
                                                                              _vm.getTypePost(
                                                                                post
                                                                              ),
                                                                            attrs:
                                                                              {
                                                                                text: _vm.$t(
                                                                                  _vm.getTypeTooltip(
                                                                                    post
                                                                                  )
                                                                                ),
                                                                                position:
                                                                                  "top",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.getTypePost(
                                                                                      post
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "state",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              `dash.posts.retweet`
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            : [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "content",
                                                                  },
                                                                  [
                                                                    ((post.page &&
                                                                      post
                                                                        .page[0] &&
                                                                      (post
                                                                        .page[0]
                                                                        .story ||
                                                                        post
                                                                          .page[0]
                                                                          .story_standard_api)) ||
                                                                      (post.draft &&
                                                                        post
                                                                          .draft
                                                                          .type ===
                                                                          "story")) &&
                                                                    ((post.page &&
                                                                      post
                                                                        .page[0] &&
                                                                      post
                                                                        .page[0]
                                                                        .video) ||
                                                                      (post.page &&
                                                                        post
                                                                          .page[0] &&
                                                                        post
                                                                          .page[0]
                                                                          .enclosure &&
                                                                        post.page[0].enclosure.endsWith(
                                                                          ".mp4"
                                                                        )) ||
                                                                      (post.draft &&
                                                                        post
                                                                          .draft
                                                                          .data
                                                                          .videos &&
                                                                        _vm.getUrlVideoDraft(
                                                                          post
                                                                            .draft
                                                                            .data
                                                                            .videos,
                                                                          post
                                                                            .page[0]
                                                                            .network,
                                                                          post
                                                                            .draft
                                                                            .type,
                                                                          post
                                                                            .draft
                                                                            .data
                                                                            .videoReel
                                                                        )))
                                                                      ? _c(
                                                                          "div",
                                                                          {},
                                                                          [
                                                                            _c(
                                                                              "video",
                                                                              {
                                                                                staticClass:
                                                                                  "story-screenshot-planner",
                                                                                attrs:
                                                                                  {
                                                                                    src:
                                                                                      post.page &&
                                                                                      post
                                                                                        .page[0] &&
                                                                                      post
                                                                                        .page[0]
                                                                                        .video
                                                                                        ? post
                                                                                            .page[0]
                                                                                            .video
                                                                                        : post.page &&
                                                                                          post
                                                                                            .page[0] &&
                                                                                          post
                                                                                            .page[0]
                                                                                            .enclosure &&
                                                                                          post.page[0].enclosure.endsWith(
                                                                                            ".mp4"
                                                                                          )
                                                                                        ? post
                                                                                            .page[0]
                                                                                            .enclosure
                                                                                        : _vm.getUrlVideoDraft(
                                                                                            post
                                                                                              .draft
                                                                                              .data
                                                                                              .videos,
                                                                                            post
                                                                                              .page[0]
                                                                                              .network,
                                                                                            post
                                                                                              .draft
                                                                                              .type,
                                                                                            post
                                                                                              .draft
                                                                                              .data
                                                                                              .videoReel
                                                                                          ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : post.page &&
                                                                        post
                                                                          .page[0] &&
                                                                        post
                                                                          .page[0]
                                                                          .videoReel &&
                                                                        ((post.page &&
                                                                          post
                                                                            .page[0] &&
                                                                          post
                                                                            .page[0]
                                                                            .video) ||
                                                                          (post.page &&
                                                                            post
                                                                              .page[0] &&
                                                                            post
                                                                              .page[0]
                                                                              .enclosure &&
                                                                            post.page[0].enclosure.endsWith(
                                                                              ".mp4"
                                                                            )) ||
                                                                          (post.draft &&
                                                                            post
                                                                              .draft
                                                                              .data
                                                                              .videos &&
                                                                            _vm.getUrlVideoDraft(
                                                                              post
                                                                                .draft
                                                                                .data
                                                                                .videos,
                                                                              post
                                                                                .page[0]
                                                                                .network,
                                                                              post
                                                                                .draft
                                                                                .type,
                                                                              post
                                                                                .draft
                                                                                .data
                                                                                .videoReel
                                                                            )))
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "video",
                                                                              {
                                                                                class: `video-thumb ${
                                                                                  ((post.page &&
                                                                                    post
                                                                                      .page[0] &&
                                                                                    post
                                                                                      .page[0]
                                                                                      .videoReel) ||
                                                                                    (post.draft &&
                                                                                      post
                                                                                        .draft
                                                                                        .data &&
                                                                                      post
                                                                                        .draft
                                                                                        .data
                                                                                        .videoReel)) &&
                                                                                  post.page &&
                                                                                  post
                                                                                    .page[0] &&
                                                                                  post
                                                                                    .page[0]
                                                                                    .network ==
                                                                                    "instagram" &&
                                                                                  "reel-video"
                                                                                }`,
                                                                                attrs:
                                                                                  {
                                                                                    width:
                                                                                      "37",
                                                                                    height:
                                                                                      "70",
                                                                                    src:
                                                                                      post.page &&
                                                                                      post
                                                                                        .page[0] &&
                                                                                      post
                                                                                        .page[0]
                                                                                        .video
                                                                                        ? post
                                                                                            .page[0]
                                                                                            .video
                                                                                        : post.page &&
                                                                                          post
                                                                                            .page[0] &&
                                                                                          post
                                                                                            .page[0]
                                                                                            .enclosure &&
                                                                                          post.page[0].enclosure.endsWith(
                                                                                            ".mp4"
                                                                                          )
                                                                                        ? post
                                                                                            .page[0]
                                                                                            .enclosure
                                                                                        : _vm.getUrlVideoDraft(
                                                                                            post
                                                                                              .draft
                                                                                              .data
                                                                                              .videos,
                                                                                            post
                                                                                              .page[0]
                                                                                              .network,
                                                                                            post
                                                                                              .draft
                                                                                              .type,
                                                                                            post
                                                                                              .draft
                                                                                              .data
                                                                                              .videoReel
                                                                                          ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm.hasScreenshot(
                                                                          post
                                                                        )
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "story-screenshot-planner",
                                                                                attrs:
                                                                                  {
                                                                                    src: _vm.hasScreenshot(
                                                                                      post
                                                                                    ),
                                                                                  },
                                                                                on: {
                                                                                  error:
                                                                                    _vm.replaceByDefault,
                                                                                },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : post.status !=
                                                                          "slot" &&
                                                                        post._bots &&
                                                                        post
                                                                          ._bots
                                                                          .length &&
                                                                        post
                                                                          ._bots[0]
                                                                          .type ==
                                                                          "linkedin" &&
                                                                        post.page &&
                                                                        post
                                                                          .page[0] &&
                                                                        post
                                                                          .page[0]
                                                                          .document_title
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "pdf",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    width:
                                                                                      "50px",
                                                                                    float:
                                                                                      "left",
                                                                                    "margin-right":
                                                                                      "5px",
                                                                                    background:
                                                                                      "transparent",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    src: post
                                                                                      .page[0]
                                                                                      .enclosure,
                                                                                    page: 1,
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : post.page &&
                                                                        post
                                                                          .page[0] &&
                                                                        post
                                                                          .page[0]
                                                                          .enclosure
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb",
                                                                                attrs:
                                                                                  {
                                                                                    src: post
                                                                                      .page[0]
                                                                                      .enclosure,
                                                                                  },
                                                                                on: {
                                                                                  error:
                                                                                    _vm.replaceByDefault,
                                                                                },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : post.page &&
                                                                        post
                                                                          .page[0] &&
                                                                        post
                                                                          .page[0]
                                                                          .carousel &&
                                                                        post
                                                                          .page[0]
                                                                          .carousel
                                                                          .length >
                                                                          1 &&
                                                                        post
                                                                          .page[0]
                                                                          .carousel[0]
                                                                          .url
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                staticClass:
                                                                                  "thumb",
                                                                                attrs:
                                                                                  {
                                                                                    src: post
                                                                                      .page[0]
                                                                                      .carousel[0]
                                                                                      .url,
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : post.enclosure
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            post.draft &&
                                                                            (post
                                                                              .draft
                                                                              .data
                                                                              .form
                                                                              .enclosure ||
                                                                              post
                                                                                .draft
                                                                                .data
                                                                                .multipleImages
                                                                                .length)
                                                                              ? _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "thumb",
                                                                                    attrs:
                                                                                      {
                                                                                        src:
                                                                                          post
                                                                                            .draft
                                                                                            .data
                                                                                            .multipleImages &&
                                                                                          post
                                                                                            .draft
                                                                                            .data
                                                                                            .multipleImages
                                                                                            .length
                                                                                            ? post
                                                                                                .draft
                                                                                                .data
                                                                                                .multipleImages[0]
                                                                                                .url
                                                                                            : post
                                                                                                .draft
                                                                                                .data
                                                                                                .form
                                                                                                .enclosure,
                                                                                      },
                                                                                    on: {
                                                                                      error:
                                                                                        _vm.replaceByDefault,
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : Array.isArray(
                                                                                  post._bots
                                                                                ) &&
                                                                                post
                                                                                  ._bots
                                                                                  .length >
                                                                                  0 &&
                                                                                post
                                                                                  ._bots[0]
                                                                                  .mode ===
                                                                                  "story" &&
                                                                                post.page &&
                                                                                post
                                                                                  .page[0] &&
                                                                                (post
                                                                                  .page[0]
                                                                                  .story ||
                                                                                  post
                                                                                    .page[0]
                                                                                    .story_standard_api)
                                                                              ? _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "story-screenshot-planner",
                                                                                    attrs:
                                                                                      {
                                                                                        src: JSON.parse(
                                                                                          post
                                                                                            .page[0]
                                                                                            .story
                                                                                        )
                                                                                          .screenshot,
                                                                                      },
                                                                                    on: {
                                                                                      error:
                                                                                        _vm.replaceByDefault,
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : post._bots &&
                                                                                post
                                                                                  ._bots
                                                                                  .mode ===
                                                                                  "story" &&
                                                                                post.page &&
                                                                                post
                                                                                  .page[0] &&
                                                                                (post
                                                                                  .page[0]
                                                                                  .story ||
                                                                                  post
                                                                                    .page[0]
                                                                                    .story_standard_api)
                                                                              ? _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "story-screenshot-planner",
                                                                                    attrs:
                                                                                      {
                                                                                        src: JSON.parse(
                                                                                          post
                                                                                            .page[0]
                                                                                            .story
                                                                                        )
                                                                                          .screenshot,
                                                                                      },
                                                                                    on: {
                                                                                      error:
                                                                                        _vm.replaceByDefault,
                                                                                    },
                                                                                  }
                                                                                )
                                                                              : _c(
                                                                                  "img",
                                                                                  {
                                                                                    staticClass:
                                                                                      "thumb",
                                                                                    attrs:
                                                                                      {
                                                                                        src: post.enclosure,
                                                                                      },
                                                                                    on: {
                                                                                      error:
                                                                                        _vm.replaceByDefault,
                                                                                    },
                                                                                  }
                                                                                ),
                                                                          ]
                                                                        )
                                                                      : (post.page &&
                                                                          post
                                                                            .page[0] &&
                                                                          post
                                                                            .page[0]
                                                                            .video) ||
                                                                        (post.draft &&
                                                                          post
                                                                            .draft
                                                                            .data
                                                                            .videos &&
                                                                          _vm.getUrlVideoDraft(
                                                                            post
                                                                              .draft
                                                                              .data
                                                                              .videos,
                                                                            post
                                                                              .page[0]
                                                                              .network,
                                                                            post
                                                                              .draft
                                                                              .type,
                                                                            post
                                                                              .draft
                                                                              .data
                                                                              .videoReel
                                                                          ))
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "thumb-wrapper",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "video",
                                                                              {
                                                                                class: `video-thumb ${
                                                                                  ((post.page &&
                                                                                    post
                                                                                      .page[0] &&
                                                                                    post
                                                                                      .page[0]
                                                                                      .videoReel) ||
                                                                                    (post.draft &&
                                                                                      post
                                                                                        .draft
                                                                                        .data &&
                                                                                      post
                                                                                        .draft
                                                                                        .data
                                                                                        .videoReel)) &&
                                                                                  post.page &&
                                                                                  post
                                                                                    .page[0] &&
                                                                                  post
                                                                                    .page[0]
                                                                                    .network ==
                                                                                    "instagram" &&
                                                                                  "reel-video"
                                                                                }`,
                                                                                attrs:
                                                                                  {
                                                                                    width:
                                                                                      "75",
                                                                                    src:
                                                                                      post.page &&
                                                                                      post
                                                                                        .page[0] &&
                                                                                      post
                                                                                        .page[0]
                                                                                        .video
                                                                                        ? post
                                                                                            .page[0]
                                                                                            .video
                                                                                        : _vm.getUrlVideoDraft(
                                                                                            post
                                                                                              .draft
                                                                                              .data
                                                                                              .videos,
                                                                                            post
                                                                                              .page[0]
                                                                                              .network,
                                                                                            post
                                                                                              .draft
                                                                                              .type,
                                                                                            post
                                                                                              .draft
                                                                                              .data
                                                                                              .videoReel
                                                                                          ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "title",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getText(
                                                                              post
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "date",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getDate(
                                                                              post
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    post.status !=
                                                                    "slot"
                                                                      ? _c(
                                                                          "Tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "type",
                                                                            class:
                                                                              _vm.getTypePost(
                                                                                post
                                                                              ),
                                                                            attrs:
                                                                              {
                                                                                text: _vm.$t(
                                                                                  _vm.getTypeTooltip(
                                                                                    post
                                                                                  )
                                                                                ),
                                                                                position:
                                                                                  "top",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.getTypePost(
                                                                                      post
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "state",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              `dash.post.${post.status}`
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm.activeDropZone &&
                                          !_vm.checkPast(day.day, index)
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "post-cell drop-post",
                                                  attrs: { draggable: "" },
                                                  on: {
                                                    dragenter: function (
                                                      $event
                                                    ) {
                                                      return _vm.dragEnterHour(
                                                        $event,
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "ul",
                                                    _vm._l(
                                                      [
                                                        0, 5, 10, 15, 20, 25,
                                                        30, 35, 40, 45, 50, 55,
                                                      ],
                                                      function (
                                                        minute,
                                                        minuteKey
                                                      ) {
                                                        return _c("li", {
                                                          key: minuteKey,
                                                          attrs: {
                                                            date: `${
                                                              index < 10
                                                                ? "0" + index
                                                                : index
                                                            }:${
                                                              minute < 10
                                                                ? "0" + minute
                                                                : minute
                                                            }`,
                                                            draggable: "",
                                                          },
                                                          on: {
                                                            dragover: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                            },
                                                            drop: function (
                                                              $event
                                                            ) {
                                                              return _vm.onDropPost(
                                                                $event,
                                                                day.day,
                                                                index,
                                                                minute
                                                              )
                                                            },
                                                            dragenter:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.dragEnter(
                                                                  $event,
                                                                  index
                                                                )
                                                              },
                                                            dragleave:
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.dragLeave(
                                                                  $event,
                                                                  index
                                                                )
                                                              },
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.gridData.monthlyCalendar
            ? _c(
                "div",
                {
                  ref: "loadableCalendarContent",
                  staticClass: "calendar-content monthly",
                },
                [
                  _c("div", { staticClass: "scrollable-x" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "calendar-body head-days",
                        attrs: { id: "calendar-content-days" },
                      },
                      _vm._l(_vm.daysWeek, function (day, key) {
                        return _c(
                          "li",
                          {
                            key: key,
                            staticClass: "column day",
                            class: `day-${key}`,
                          },
                          [
                            _c(
                              "ul",
                              {
                                staticClass: "calendar-head",
                                class: { fixed: _vm.fixedDays },
                              },
                              [
                                _c("li", { staticClass: "column day-column" }, [
                                  _c("p", [
                                    _c("span", { staticClass: "day" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t(`dash.week.${day}`)
                                            .substr(0, 3)
                                        )
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      { attrs: { id: "calendar-content-monthly" } },
                      _vm._l(
                        _vm.gridData.monthlyCalendar,
                        function (day, indexDay) {
                          return _c(
                            "div",
                            {
                              key: indexDay,
                              staticClass: "day",
                              class: {
                                current: _vm.checkCurrent(day.dateText, true),
                                month: _vm.checkMonth(day.dateText),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addPost(day.dateText, null)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "date" }, [
                                _vm._v(_vm._s(day.date)),
                              ]),
                              _vm.nbPostsDayMonthly(day.posts)
                                ? _c("div", { staticClass: "count" }, [
                                    _vm._v(
                                      _vm._s(_vm.nbPostsDayMonthly(day.posts))
                                    ),
                                  ])
                                : _vm._e(),
                              _c(
                                "ul",
                                { staticClass: "posts" },
                                _vm._l(day.posts, function (post, indexPost) {
                                  return _c(
                                    "div",
                                    {
                                      key: indexPost,
                                      staticClass: "post-cell",
                                    },
                                    [
                                      _vm.showPost(post)
                                        ? _c(
                                            "li",
                                            {
                                              staticClass: "post",
                                              class: [
                                                post.status,
                                                {
                                                  reshare:
                                                    post.page &&
                                                    post.page[0] &&
                                                    post.page[0].is_reshare,
                                                },
                                                {
                                                  retweet:
                                                    post.page &&
                                                    post.page[0] &&
                                                    post.page[0].is_retweet,
                                                },
                                                {
                                                  story:
                                                    (post.page &&
                                                      post.page[0] &&
                                                      (post.page[0].story ||
                                                        post.page[0]
                                                          .story_standard_api)) ||
                                                    (post.draft &&
                                                      (post.draft.type ===
                                                        "story" ||
                                                        post.draft.data
                                                          .typePost ===
                                                          "story")),
                                                },
                                              ],
                                              attrs: {
                                                "data-qa": `planner-post-${post.status}`,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.clickPost(
                                                    _vm.gridData.pages,
                                                    post
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              post._bots &&
                                              post._bots.length &&
                                              post._bots[0].page &&
                                              post._bots[0].page.name
                                                ? _c(
                                                    "div",
                                                    { staticClass: "page-rs" },
                                                    [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: post._bots[0]
                                                              .page.name,
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "page-image-avatar",
                                                            {
                                                              attrs: {
                                                                page: post
                                                                  ._bots[0]
                                                                  .page,
                                                              },
                                                            }
                                                          ),
                                                          _vm._v(
                                                            "\n                     \n                  "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              post.page &&
                                              post.page.length &&
                                              ((post.page[0].wait_validation &&
                                                (typeof post.page[0]
                                                  .wait_validation ==
                                                  "object" ||
                                                  JSON.parse(
                                                    post.page[0].wait_validation
                                                  ))) ||
                                                post.page[0].affectedTo)
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "affected-to",
                                                    },
                                                    [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.$t(
                                                              post.page[0]
                                                                .wait_validation &&
                                                                (typeof post
                                                                  .page[0]
                                                                  .wait_validation ==
                                                                  "object" ||
                                                                  JSON.parse(
                                                                    post.page[0]
                                                                      .wait_validation
                                                                  ))
                                                                ? "dash.posts.validated"
                                                                : "dash.posts.affected_and_not_validated"
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("img", {
                                                            attrs: {
                                                              src: require(post
                                                                .page[0]
                                                                .wait_validation &&
                                                                (typeof post
                                                                  .page[0]
                                                                  .wait_validation ==
                                                                  "object" ||
                                                                  JSON.parse(
                                                                    post.page[0]
                                                                      .wait_validation
                                                                  ))
                                                                ? "../../assets/img/check_mark_accept_icon.svg"
                                                                : "../../assets/img/check_mark_accept_icon_grey.svg"),
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                     \n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              post.status == "preview" ||
                                              post.status == "slot" ||
                                              post.status == "failed" ||
                                              post.status == "inprogress" ||
                                              (post.page &&
                                                post.page[0] &&
                                                (post.page[0].story ||
                                                  post.page[0]
                                                    .story_standard_api))
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "content",
                                                      },
                                                      [
                                                        _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.$t(
                                                                _vm.getTooltip(
                                                                  post
                                                                )
                                                              ),
                                                              position: "top",
                                                            },
                                                          },
                                                          [
                                                            ((post.page &&
                                                              post.page[0] &&
                                                              (post.page[0]
                                                                .story ||
                                                                post.page[0]
                                                                  .story_standard_api)) ||
                                                              (post.draft &&
                                                                post.draft
                                                                  .type ===
                                                                  "story")) &&
                                                            ((post.page &&
                                                              post.page[0] &&
                                                              post.page[0]
                                                                .video) ||
                                                              (post.page &&
                                                                post.page[0] &&
                                                                post.page[0]
                                                                  .enclosure &&
                                                                post.page[0].enclosure.endsWith(
                                                                  ".mp4"
                                                                )) ||
                                                              (post.draft &&
                                                                post.draft.data
                                                                  .videos &&
                                                                _vm.getUrlVideoDraft(
                                                                  post.draft
                                                                    .data
                                                                    .videos,
                                                                  post.page[0]
                                                                    .network,
                                                                  post.draft
                                                                    .type,
                                                                  post.draft
                                                                    .data
                                                                    .videoReel
                                                                )))
                                                              ? _c("div", {}, [
                                                                  _c("video", {
                                                                    staticClass:
                                                                      "story-screenshot-planner",
                                                                    attrs: {
                                                                      src:
                                                                        post.page &&
                                                                        post
                                                                          .page[0] &&
                                                                        post
                                                                          .page[0]
                                                                          .video
                                                                          ? post
                                                                              .page[0]
                                                                              .video
                                                                          : post.page &&
                                                                            post
                                                                              .page[0] &&
                                                                            post
                                                                              .page[0]
                                                                              .enclosure &&
                                                                            post.page[0].enclosure.endsWith(
                                                                              ".mp4"
                                                                            )
                                                                          ? post
                                                                              .page[0]
                                                                              .enclosure
                                                                          : _vm.getUrlVideoDraft(
                                                                              post
                                                                                .draft
                                                                                .data
                                                                                .videos,
                                                                              post
                                                                                .page[0]
                                                                                .network,
                                                                              post
                                                                                .draft
                                                                                .type,
                                                                              post
                                                                                .draft
                                                                                .data
                                                                                .videoReel
                                                                            ),
                                                                    },
                                                                  }),
                                                                ])
                                                              : post.page &&
                                                                post.page[0] &&
                                                                post.page[0]
                                                                  .videoReel &&
                                                                ((post.page &&
                                                                  post
                                                                    .page[0] &&
                                                                  post.page[0]
                                                                    .video) ||
                                                                  (post.page &&
                                                                    post
                                                                      .page[0] &&
                                                                    post.page[0]
                                                                      .enclosure &&
                                                                    post.page[0].enclosure.endsWith(
                                                                      ".mp4"
                                                                    )) ||
                                                                  (post.draft &&
                                                                    post.draft
                                                                      .data
                                                                      .videos &&
                                                                    _vm.getUrlVideoDraft(
                                                                      post.draft
                                                                        .data
                                                                        .videos,
                                                                      post
                                                                        .page[0]
                                                                        .network,
                                                                      post.draft
                                                                        .type,
                                                                      post.draft
                                                                        .data
                                                                        .videoReel
                                                                    )))
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "thumb-wrapper",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "video",
                                                                      {
                                                                        class: `video-thumb ${
                                                                          ((post.page &&
                                                                            post
                                                                              .page[0] &&
                                                                            post
                                                                              .page[0]
                                                                              .videoReel) ||
                                                                            (post.draft &&
                                                                              post
                                                                                .draft
                                                                                .data &&
                                                                              post
                                                                                .draft
                                                                                .data
                                                                                .videoReel)) &&
                                                                          post.page &&
                                                                          post
                                                                            .page[0] &&
                                                                          post
                                                                            .page[0]
                                                                            .network ==
                                                                            "instagram" &&
                                                                          "reel-video"
                                                                        }`,
                                                                        attrs: {
                                                                          width:
                                                                            "37",
                                                                          height:
                                                                            "70",
                                                                          src:
                                                                            post.page &&
                                                                            post
                                                                              .page[0] &&
                                                                            post
                                                                              .page[0]
                                                                              .video
                                                                              ? post
                                                                                  .page[0]
                                                                                  .video
                                                                              : post.page &&
                                                                                post
                                                                                  .page[0] &&
                                                                                post
                                                                                  .page[0]
                                                                                  .enclosure &&
                                                                                post.page[0].enclosure.endsWith(
                                                                                  ".mp4"
                                                                                )
                                                                              ? post
                                                                                  .page[0]
                                                                                  .enclosure
                                                                              : _vm.getUrlVideoDraft(
                                                                                  post
                                                                                    .draft
                                                                                    .data
                                                                                    .videos,
                                                                                  post
                                                                                    .page[0]
                                                                                    .network,
                                                                                  post
                                                                                    .draft
                                                                                    .type,
                                                                                  post
                                                                                    .draft
                                                                                    .data
                                                                                    .videoReel
                                                                                ),
                                                                        },
                                                                      }
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm.hasScreenshot(
                                                                  post
                                                                )
                                                              ? _c("div", [
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "story-screenshot-planner",
                                                                    attrs: {
                                                                      src: _vm.hasScreenshot(
                                                                        post
                                                                      ),
                                                                    },
                                                                    on: {
                                                                      error:
                                                                        _vm.replaceByDefault,
                                                                    },
                                                                  }),
                                                                ])
                                                              : post.status !=
                                                                  "slot" &&
                                                                ((post
                                                                  ._bots[0] &&
                                                                  post._bots[0]
                                                                    .mode ===
                                                                    "story" &&
                                                                  post._bots[0]
                                                                    .page &&
                                                                  post._bots[0]
                                                                    .page
                                                                    .story_config &&
                                                                  post._bots[0]
                                                                    .page
                                                                    .story_config
                                                                    .created) ||
                                                                  (post._bots &&
                                                                    post._bots
                                                                      .mode ===
                                                                      "story" &&
                                                                    post._bots
                                                                      .page &&
                                                                    post._bots
                                                                      .page
                                                                      .story_config &&
                                                                    post._bots
                                                                      .page
                                                                      .story_config
                                                                      .created))
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "story-img-planner",
                                                                  },
                                                                  [
                                                                    _c("img", {
                                                                      attrs: {
                                                                        src: post.enclosure,
                                                                        alt: "",
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.replaceByDefault,
                                                                      },
                                                                    }),
                                                                    _c("p", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getText(
                                                                            post,
                                                                            true
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                )
                                                              : post.status !=
                                                                  "slot" &&
                                                                post.enclosure
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "thumb-wrapper",
                                                                  },
                                                                  [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "thumb",
                                                                      attrs: {
                                                                        src: post.enclosure,
                                                                      },
                                                                    }),
                                                                  ]
                                                                )
                                                              : post.status !=
                                                                  "slot" &&
                                                                post.page &&
                                                                post.page[0] &&
                                                                post.page[0]
                                                                  .enclosure
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "thumb-wrapper",
                                                                  },
                                                                  [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "thumb",
                                                                      attrs: {
                                                                        src: post
                                                                          .page[0]
                                                                          .enclosure,
                                                                      },
                                                                    }),
                                                                  ]
                                                                )
                                                              : post.status !=
                                                                  "slot" &&
                                                                post.page &&
                                                                post.page[0] &&
                                                                post.page[0]
                                                                  .carousel &&
                                                                post.page[0]
                                                                  .carousel
                                                                  .length > 1 &&
                                                                post.page[0]
                                                                  .carousel[0]
                                                                  .url
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "thumb-wrapper",
                                                                  },
                                                                  [
                                                                    _c("img", {
                                                                      staticClass:
                                                                        "thumb",
                                                                      attrs: {
                                                                        src: post
                                                                          .page[0]
                                                                          .carousel[0]
                                                                          .url,
                                                                      },
                                                                    }),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            post.status !=
                                                            "slot"
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.getText(
                                                                          post
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          `dash.post.slot.empty`
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "info" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "date",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getDate(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        post.status != "slot"
                                                          ? _c(
                                                              "Tooltip",
                                                              {
                                                                staticClass:
                                                                  "type",
                                                                class:
                                                                  _vm.getTypePost(
                                                                    post
                                                                  ),
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    _vm.getTypeTooltip(
                                                                      post
                                                                    )
                                                                  ),
                                                                  position:
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getTypePost(
                                                                        post
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "state",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  `dash.post.${post.status}`
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : post.page &&
                                                  post.page[0] &&
                                                  post.page[0].is_reshare
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "content",
                                                      },
                                                      [
                                                        post.page &&
                                                        post.page[0] &&
                                                        post.page[0].enclosure
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "thumb",
                                                                  attrs: {
                                                                    src: post
                                                                      .page[0]
                                                                      .enclosure,
                                                                  },
                                                                  on: {
                                                                    error:
                                                                      _vm.replaceByDefault,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : post.enclosure
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "thumb",
                                                                  attrs: {
                                                                    src: post.enclosure,
                                                                  },
                                                                  on: {
                                                                    error:
                                                                      _vm.replaceByDefault,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                post.page[0]
                                                                  .reshare_message
                                                              ) +
                                                                " - " +
                                                                _vm._s(
                                                                  _vm.getText(
                                                                    post
                                                                  )
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "info" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "date",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getDate(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        post.status != "slot"
                                                          ? _c(
                                                              "Tooltip",
                                                              {
                                                                staticClass:
                                                                  "type",
                                                                class:
                                                                  _vm.getTypePost(
                                                                    post
                                                                  ),
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    _vm.getTypeTooltip(
                                                                      post
                                                                    )
                                                                  ),
                                                                  position:
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getTypePost(
                                                                        post
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "state",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  `dash.post.reshare`
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : post.page &&
                                                  post.page[0] &&
                                                  post.page[0].is_retweet
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "content",
                                                      },
                                                      [
                                                        post.page &&
                                                        post.page[0] &&
                                                        post.page[0].enclosure
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "thumb",
                                                                  attrs: {
                                                                    src: post
                                                                      .page[0]
                                                                      .enclosure,
                                                                  },
                                                                  on: {
                                                                    error:
                                                                      _vm.replaceByDefault,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : post.enclosure
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "thumb",
                                                                  attrs: {
                                                                    src: post.enclosure,
                                                                  },
                                                                  on: {
                                                                    error:
                                                                      _vm.replaceByDefault,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getText(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "info" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "date",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getDate(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        post.status != "slot"
                                                          ? _c(
                                                              "Tooltip",
                                                              {
                                                                staticClass:
                                                                  "type",
                                                                class:
                                                                  _vm.getTypePost(
                                                                    post
                                                                  ),
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    _vm.getTypeTooltip(
                                                                      post
                                                                    )
                                                                  ),
                                                                  position:
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getTypePost(
                                                                        post
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "state",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  `dash.posts.retweet`
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "content",
                                                      },
                                                      [
                                                        ((post.page &&
                                                          post.page[0] &&
                                                          (post.page[0].story ||
                                                            post.page[0]
                                                              .story_standard_api)) ||
                                                          (post.draft &&
                                                            post.draft.type ===
                                                              "story")) &&
                                                        ((post.page &&
                                                          post.page[0] &&
                                                          post.page[0].video) ||
                                                          (post.page &&
                                                            post.page[0] &&
                                                            post.page[0]
                                                              .enclosure &&
                                                            post.page[0].enclosure.endsWith(
                                                              ".mp4"
                                                            )) ||
                                                          (post.draft &&
                                                            post.draft.data
                                                              .videos &&
                                                            _vm.getUrlVideoDraft(
                                                              post.draft.data
                                                                .videos,
                                                              post.page[0]
                                                                .network,
                                                              post.draft.type,
                                                              post.draft.data
                                                                .videoReel
                                                            )))
                                                          ? _c("div", {}, [
                                                              _c("video", {
                                                                staticClass:
                                                                  "story-screenshot-planner",
                                                                attrs: {
                                                                  src:
                                                                    post.page &&
                                                                    post
                                                                      .page[0] &&
                                                                    post.page[0]
                                                                      .video
                                                                      ? post
                                                                          .page[0]
                                                                          .video
                                                                      : post.page &&
                                                                        post
                                                                          .page[0] &&
                                                                        post
                                                                          .page[0]
                                                                          .enclosure &&
                                                                        post.page[0].enclosure.endsWith(
                                                                          ".mp4"
                                                                        )
                                                                      ? post
                                                                          .page[0]
                                                                          .enclosure
                                                                      : _vm.getUrlVideoDraft(
                                                                          post
                                                                            .draft
                                                                            .data
                                                                            .videos,
                                                                          post
                                                                            .page[0]
                                                                            .network,
                                                                          post
                                                                            .draft
                                                                            .type,
                                                                          post
                                                                            .draft
                                                                            .data
                                                                            .videoReel
                                                                        ),
                                                                },
                                                              }),
                                                            ])
                                                          : post.page &&
                                                            post.page[0] &&
                                                            post.page[0]
                                                              .videoReel &&
                                                            ((post.page &&
                                                              post.page[0] &&
                                                              post.page[0]
                                                                .video) ||
                                                              (post.page &&
                                                                post.page[0] &&
                                                                post.page[0]
                                                                  .enclosure &&
                                                                post.page[0].enclosure.endsWith(
                                                                  ".mp4"
                                                                )) ||
                                                              (post.draft &&
                                                                post.draft.data
                                                                  .videos &&
                                                                _vm.getUrlVideoDraft(
                                                                  post.draft
                                                                    .data
                                                                    .videos,
                                                                  post.page[0]
                                                                    .network,
                                                                  post.draft
                                                                    .type,
                                                                  post.draft
                                                                    .data
                                                                    .videoReel
                                                                )))
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("video", {
                                                                  class: `video-thumb ${
                                                                    ((post.page &&
                                                                      post
                                                                        .page[0] &&
                                                                      post
                                                                        .page[0]
                                                                        .videoReel) ||
                                                                      (post.draft &&
                                                                        post
                                                                          .draft
                                                                          .data &&
                                                                        post
                                                                          .draft
                                                                          .data
                                                                          .videoReel)) &&
                                                                    post.page &&
                                                                    post
                                                                      .page[0] &&
                                                                    post.page[0]
                                                                      .network ==
                                                                      "instagram" &&
                                                                    "reel-video"
                                                                  }`,
                                                                  attrs: {
                                                                    width: "37",
                                                                    height:
                                                                      "70",
                                                                    src:
                                                                      post.page &&
                                                                      post
                                                                        .page[0] &&
                                                                      post
                                                                        .page[0]
                                                                        .video
                                                                        ? post
                                                                            .page[0]
                                                                            .video
                                                                        : post.page &&
                                                                          post
                                                                            .page[0] &&
                                                                          post
                                                                            .page[0]
                                                                            .enclosure &&
                                                                          post.page[0].enclosure.endsWith(
                                                                            ".mp4"
                                                                          )
                                                                        ? post
                                                                            .page[0]
                                                                            .enclosure
                                                                        : _vm.getUrlVideoDraft(
                                                                            post
                                                                              .draft
                                                                              .data
                                                                              .videos,
                                                                            post
                                                                              .page[0]
                                                                              .network,
                                                                            post
                                                                              .draft
                                                                              .type,
                                                                            post
                                                                              .draft
                                                                              .data
                                                                              .videoReel
                                                                          ),
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm.hasScreenshot(
                                                              post
                                                            )
                                                          ? _c("div", [
                                                              _c("img", {
                                                                staticClass:
                                                                  "story-screenshot-planner",
                                                                attrs: {
                                                                  src: _vm.hasScreenshot(
                                                                    post
                                                                  ),
                                                                },
                                                                on: {
                                                                  error:
                                                                    _vm.replaceByDefault,
                                                                },
                                                              }),
                                                            ])
                                                          : post.status !=
                                                              "slot" &&
                                                            post._bots &&
                                                            post._bots.length &&
                                                            post._bots[0]
                                                              .type ==
                                                              "linkedin" &&
                                                            post.page &&
                                                            post.page[0] &&
                                                            post.page[0]
                                                              .document_title
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("pdf", {
                                                                  staticStyle: {
                                                                    width:
                                                                      "50px",
                                                                    float:
                                                                      "left",
                                                                    "margin-right":
                                                                      "5px",
                                                                    background:
                                                                      "transparent",
                                                                  },
                                                                  attrs: {
                                                                    src: post
                                                                      .page[0]
                                                                      .enclosure,
                                                                    page: 1,
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            )
                                                          : post.page &&
                                                            post.page[0] &&
                                                            post.page[0]
                                                              .enclosure
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "thumb",
                                                                  attrs: {
                                                                    src: post
                                                                      .page[0]
                                                                      .enclosure,
                                                                  },
                                                                  on: {
                                                                    error:
                                                                      _vm.replaceByDefault,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : post.page &&
                                                            post.page[0] &&
                                                            post.page[0]
                                                              .carousel &&
                                                            post.page[0]
                                                              .carousel.length >
                                                              1 &&
                                                            post.page[0]
                                                              .carousel[0].url
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  staticClass:
                                                                    "thumb",
                                                                  attrs: {
                                                                    src: post
                                                                      .page[0]
                                                                      .carousel[0]
                                                                      .url,
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : post.enclosure
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                post.draft &&
                                                                (post.draft.data
                                                                  .form
                                                                  .enclosure ||
                                                                  post.draft
                                                                    .data
                                                                    .multipleImages
                                                                    .length)
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "thumb",
                                                                      attrs: {
                                                                        src:
                                                                          post
                                                                            .draft
                                                                            .data
                                                                            .multipleImages &&
                                                                          post
                                                                            .draft
                                                                            .data
                                                                            .multipleImages
                                                                            .length
                                                                            ? post
                                                                                .draft
                                                                                .data
                                                                                .multipleImages[0]
                                                                                .url
                                                                            : post
                                                                                .draft
                                                                                .data
                                                                                .form
                                                                                .enclosure,
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.replaceByDefault,
                                                                      },
                                                                    })
                                                                  : Array.isArray(
                                                                      post._bots
                                                                    ) &&
                                                                    post._bots
                                                                      .length >
                                                                      0 &&
                                                                    post
                                                                      ._bots[0]
                                                                      .mode ===
                                                                      "story" &&
                                                                    post.page &&
                                                                    post
                                                                      .page[0] &&
                                                                    (post
                                                                      .page[0]
                                                                      .story ||
                                                                      post
                                                                        .page[0]
                                                                        .story_standard_api)
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "story-screenshot-planner",
                                                                      attrs: {
                                                                        src: JSON.parse(
                                                                          post
                                                                            .page[0]
                                                                            .story
                                                                        )
                                                                          .screenshot,
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.replaceByDefault,
                                                                      },
                                                                    })
                                                                  : post._bots &&
                                                                    post._bots
                                                                      .mode ===
                                                                      "story" &&
                                                                    post.page &&
                                                                    post
                                                                      .page[0] &&
                                                                    (post
                                                                      .page[0]
                                                                      .story ||
                                                                      post
                                                                        .page[0]
                                                                        .story_standard_api)
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "story-screenshot-planner",
                                                                      attrs: {
                                                                        src: JSON.parse(
                                                                          post
                                                                            .page[0]
                                                                            .story
                                                                        )
                                                                          .screenshot,
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.replaceByDefault,
                                                                      },
                                                                    })
                                                                  : _c("img", {
                                                                      staticClass:
                                                                        "thumb",
                                                                      attrs: {
                                                                        src: post.enclosure,
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.replaceByDefault,
                                                                      },
                                                                    }),
                                                              ]
                                                            )
                                                          : (post.page &&
                                                              post.page[0] &&
                                                              post.page[0]
                                                                .video) ||
                                                            (post.draft &&
                                                              post.draft.data
                                                                .videos &&
                                                              _vm.getUrlVideoDraft(
                                                                post.draft.data
                                                                  .videos,
                                                                post.page[0]
                                                                  .network,
                                                                post.draft.type,
                                                                post.draft.data
                                                                  .videoReel
                                                              ))
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                _c("video", {
                                                                  class: `video-thumb ${
                                                                    ((post.page &&
                                                                      post
                                                                        .page[0] &&
                                                                      post
                                                                        .page[0]
                                                                        .videoReel) ||
                                                                      (post.draft &&
                                                                        post
                                                                          .draft
                                                                          .data &&
                                                                        post
                                                                          .draft
                                                                          .data
                                                                          .videoReel)) &&
                                                                    post.page &&
                                                                    post
                                                                      .page[0] &&
                                                                    post.page[0]
                                                                      .network ==
                                                                      "instagram" &&
                                                                    "reel-video"
                                                                  }`,
                                                                  attrs: {
                                                                    width: "75",
                                                                    src:
                                                                      post.page &&
                                                                      post
                                                                        .page[0] &&
                                                                      post
                                                                        .page[0]
                                                                        .video
                                                                        ? post
                                                                            .page[0]
                                                                            .video
                                                                        : _vm.getUrlVideoDraft(
                                                                            post
                                                                              .draft
                                                                              .data
                                                                              .videos,
                                                                            post
                                                                              .page[0]
                                                                              .network,
                                                                            post
                                                                              .draft
                                                                              .type,
                                                                            post
                                                                              .draft
                                                                              .data
                                                                              .videoReel
                                                                          ),
                                                                  },
                                                                }),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getText(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "info" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "date",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getDate(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        post.status != "slot"
                                                          ? _c(
                                                              "Tooltip",
                                                              {
                                                                staticClass:
                                                                  "type",
                                                                class:
                                                                  _vm.getTypePost(
                                                                    post
                                                                  ),
                                                                attrs: {
                                                                  text: _vm.$t(
                                                                    _vm.getTypeTooltip(
                                                                      post
                                                                    )
                                                                  ),
                                                                  position:
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getTypePost(
                                                                        post
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "state",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  `dash.post.${post.status}`
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "vs-popup",
            {
              class: `sidebar-action ${_vm.version}`,
              attrs: { title: ``, active: _vm.showSidebar },
              on: {
                "update:active": function ($event) {
                  _vm.showSidebar = $event
                },
              },
            },
            [
              _vm.gridData.pages && _vm.post && _vm.post._bots
                ? _c("component-post-sidebar", {
                    attrs: {
                      gridData: _vm.gridData,
                      postOriginal: _vm.post,
                      sectionPlanner: true,
                      openPostSidebar: _vm.openPostSidebar,
                    },
                    on: {
                      edit: _vm.editPost,
                      validate: _vm.validatePostEvent,
                      deleteScheduled: _vm.deleteScheduledEvent,
                      add: _vm.addPostEvent,
                      excludeNews: _vm.excludeNewsEvent,
                      deleteSlot: _vm.deleteSlotEvent,
                      resharePost: _vm.resharePost,
                      retweetPost: _vm.retweetPost,
                      openLoader: _vm.openLoader,
                      validateScheduledPost: _vm.validateScheduledPostEvent,
                      removeValidateScheduledPost:
                        _vm.removeValidateScheduledPostEvent,
                      validateDraft: _vm.validateDraftEvent,
                      addComment: _vm.addComment,
                      shareStory: _vm.shareToStory,
                      editDraft: _vm.editDraft,
                      removeDrafts: _vm.removeDrafts,
                      duplicatePost: _vm.duplicatePost,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }